import styled from "styled-components"

import {Body} from "@irati/ui/src/Typography"

const MarginLeftBody = styled(Body)`
  margin-left: 10px;
  cursor: pointer;
`

export default MarginLeftBody
